import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

//import { CALENDAR_EVENT_TYPE_IDS } from '../../libs/calendarConfig';
import { getUserAssignmentTypeDisplay } from '../../libs/user';

//- ui
import DateHeader from './DateHeader';
import UserRowHeader from './Cells/UserRowHeader';
import Cell from './Cell';
import blueSemiTruckSvg from '../../images/calendar/blueSemiTruck.svg';
import unavailableSemiTruckSvg from '../../images/calendar/unavailableSemiTruck.svg';
import WorkDay from './Cells/WorkDay';

import { statuses } from './WorkDayStatuses';
const isWorkingStatusMap = {};
statuses.forEach(({ value, isWorking }) => {
	if (isWorking) {
		isWorkingStatusMap[value] = true;
	}
});

function rgba(rgb, a) {
	const { r, g, b } = rgb;
	return `rgba(${r},${g},${b},${a})`;
}
const openColor = 'rgba(232, 245, 233,.6)';
const unavailableColor = 'rgba(255, 253, 231,.6)';
const groupColors = [
	{ r: 149, g: 117, b: 205 },
	{ r: 100, g: 181, b: 246 },
	{ r: 174, g: 213, b: 129 },
	{ r: 255, g: 183, b: 77 },
	{ r: 255, g: 138, b: 101 },
	{ r: 229, g: 115, b: 115 },
	{ r: 186, g: 104, b: 200 },
];

const styles = () => {
	return {
		tableContainer: {
			width: '100%',
			tableLayout: 'auto',
			display: 'table',
			borderSpacing: 0,
			borderCollapse: 'collapse',
		},
		blueSemiTruckIcon: {
			display: 'inline-block',
			width: 31,
			height: 33,
			backgroundImage: `url('${blueSemiTruckSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 5,
		},
		unavailableSemiTruckIcon: {
			display: 'inline-block',
			width: 31,
			height: 33,
			backgroundImage: `url('${unavailableSemiTruckSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 5,
		},
		openTruck: {
			margin: 5,
			whiteSpace: 'nowrap',
			fontWeight: 700,
			color: '#555',
		},
		openTruckCell: {
			backgroundColor: openColor,
			borderBottom: '1px solid #888',
			verticalAlign: 'bottom',
		},
		openTruckCellHeader: {
			backgroundColor: openColor,
			borderBottom: '1px solid #888',
			verticalAlign: 'middle',
		},
		unavailableTruck: {
			margin: 5,
			whiteSpace: 'nowrap',
			fontWeight: 700,
			color: '#555',
		},
		unavailableTruckCell: {
			backgroundColor: unavailableColor,
			borderBottom: '1px solid #888',
			verticalAlign: 'bottom',
		},
		unavailableTruckCellHeader: {
			backgroundColor: unavailableColor,
			borderBottom: '1px solid #888',
			verticalAlign: 'middle',
		},
		editHover: {
			position: 'absolute',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			transition: '0.3s',
			cursor: 'pointer',
			border: '1px solid rgba(255,255,255,.1)',
			zIndex: 100,
			'&:hover': {
				border: '1px solid rgba(32,150,243,.8)',
				backgroundColor: `rgba(32,150,243,.2)`,
			},
		},
		topTotalRow: {
			borderTop: '2px solid #888',
		},
		totalCellHeader: {
			lineHeight: 1.3,
			textAlign: 'right',
			fontWeight: 500,
			color: '#444',
		},
		totalCell: {
			backgroundColor: '#eff0f3',
			padding: `5px 10px`,
			borderBottom: '1px solid #ddd',
			//borderTop : '2px solid #888',
			verticalAlign: 'top',
		},
		totalRowExtraStats: {
			marginLeft: 10,
			fontSize: '90%',
		},
		sortGroupCell: {
			border: `1px solid #bbb`,
			overflowX: 'hidden',
			height: 'auto',
			position: 'relative',
			padding: 10,
			//backgroundColor : '#D1C4E9',
			textTransform: 'uppercase',
			letterSpacing: 2,
			color: 'white',
			fontWeight: 500,
		},
	};
};

class DriverRoomBody extends Component {
	constructor(props) {
		super(props);

		this.state = {
			userRows: [],
			workDayMap: {},
			openShiftDateMap: {},
			openTrucksByDate: {},

			workDayForUpdatingDialog: undefined,
			assignedLocationIdForDialog: undefined,
			openTrucksForDialog: undefined,
			isUpdatingDialogOpen: false,
			unavailableTruckForDialog: undefined,
		};
	}

	static getDerivedStateFromProps(props) {
		const { sortBy, searchResult } = props;
		const response = searchResult;

		const workDays = _.get(response, 'collections.workDayCollection', []);
		const openTrucks = _.get(response, 'collections.openTruckCollection', []);
		const unavailableTrucks = _.get(response, 'collections.unavailableTruckCollection', []);

		const userMap = _.keyBy(_.get(response, 'collections.userCollection', []), 'userId');
		const shiftMap = _.keyBy(_.get(response, 'collections.shiftCollection', []), 'shiftId');
		const locationMap = _.keyBy(
			_.get(response, 'collections.locationCollection', []),
			'locationId'
		);

		// Process the result
		const workDayMap = _.keyBy(workDays, 'workDayId');
		const userWorkDaysByDate = _.groupBy(workDays, 'date');
		const openTrucksByDate = _.groupBy(openTrucks, 'date');
		const openTruckMap = _.keyBy(openTrucks, 'openTruckId');
		const unavailableTrucksByDate = _.groupBy(unavailableTrucks, 'date');
		const unavailableTruckMap = _.keyBy(unavailableTrucks, 'unavailableTruckId');

		const userGroups = _.groupBy(workDays, 'userId');

		const userRows = _.reduce(
			userGroups,
			(acc, userWorkDays, userId) => {
				userId = _.parseInt(userId);
				const user = userMap[userId] || {};
				if (!user) {
					return acc;
				}
				if (user.role !== 'driver') {
					return acc;
				}

				const display =
					sortBy === 'lastName'
						? `${user.lastName}, ${user.firstName}`
						: `${user.firstName} ${user.lastName}`;

				const userWorkDaysByDate = userWorkDays.reduce((acc, workDay) => {
					const date = workDay.date;
					if (!acc[date]) {
						acc[date] = [];
					}
					acc[date].push(workDay);
					return acc;
				}, {});

				let assignedUserAssignmentTypeId = null;
				let assignedLocationId = undefined;
				//- Better way to do this
				let sortValue = userId;

				if (sortBy === 'firstName') {
					sortValue = user.firstName;
				} else if (sortBy === 'lastName') {
					sortValue = user.lastName;
				} else if (sortBy === 'shiftTime' && userWorkDays[0]) {
					const shiftTime = _.get(userWorkDays, '0.shiftTime');
					sortValue = shiftTime ? shiftTime : '9999999999';
				} else if (sortBy === 'location') {
					const shiftId = _.get(userWorkDays, '0.shiftId');
					const shiftTime = _.get(userWorkDays, '0.shiftTime');
					sortValue = assignedLocationId + '_' + shiftId + '_' + shiftTime;
				}

				const row = {
					userId,
					sortValue,
					display,
					displayLink: `/user/update/${userId}`,
					userWorkDaysByDate,
					userAssignmentTypeId: assignedUserAssignmentTypeId,
					assignedLocationId,
				};

				acc.push(row);
				return acc;
			},
			[]
		);

		return {
			workDayMap,
			userRows: _.sortBy(userRows, 'sortValue'),
			userWorkDaysByDate,
			openTrucksByDate,
			openTruckMap,
			unavailableTrucksByDate,
			unavailableTruckMap,
			userMap,
			shiftMap,
			locationMap,
		};
	}

	render() {
		const { classes, today, dateColumns, numberOfDays, useShiftIdAsHeader } = this.props;

		const { shiftMap } = this.state;

		let cornerDisplay = 'Driver';
		if (useShiftIdAsHeader && shiftMap) {
			const shift = shiftMap[useShiftIdAsHeader] || { display: '?' };
			cornerDisplay = shift.display + ' Shift';
		}

		return (
			<Fragment>
				<table className={classes.tableContainer}>
					<thead>
						<DateHeader
							dateColumns={dateColumns}
							today={today}
							numberOfDays={numberOfDays}
							isDriverRoom={true}
							cornerDisplay={cornerDisplay}
						/>
					</thead>
					<tbody>{this.renderRows()}</tbody>
				</table>
			</Fragment>
		);
	}

	renderRows() {
		const { dateColumns, numberOfDays, classes, sortBy } = this.props;

		const { userRows, userMap, shiftMap, locationMap } = this.state;

		if (_.isEmpty(userRows)) {
			return;
		}

		let lastLocationId;
		let lastTypeId;
		let currentGroupIndex = 0;

		let userRowCount = userRows.length;
		return userRows.map((row, index) => {
			const {
				sortValue,
				userAssignmentTypeId,
				assignedLocationId,
				userId,
				userWorkDaysByDate,
				display,
				subDisplay,
				displayLink,
			} = row;

			//- Used when sorting by terminal
			let sortRow = null;

			if (sortBy === 'location' && lastLocationId !== assignedLocationId) {
				lastLocationId = assignedLocationId;
				const color = groupColors[currentGroupIndex % groupColors.length];
				const style = {
					background:
						`linear-gradient(to right, ${rgba(color, 1)} 0%,` +
						`${rgba(color, 0.75)} 20%,` +
						`${rgba(color, 0)} 98%)`,
				};
				currentGroupIndex++;

				const location = locationMap[assignedLocationId] || { display: 'Missing' };
				sortRow = (
					<tr key={sortValue}>
						<td className={classes.sortGroupCell} style={style} colSpan={numberOfDays + 1}>
							{location.display}
						</td>
					</tr>
				);
			}

			if (sortBy === 'schedule' && lastTypeId !== userAssignmentTypeId) {
				lastTypeId = userAssignmentTypeId;
				const color = groupColors[currentGroupIndex % groupColors.length];
				const style = {
					background:
						`linear-gradient(to right, ${rgba(color, 1)} 0%,` +
						`${rgba(color, 0.75)} 20%,` +
						`${rgba(color, 0)} 98%)`,
				};
				currentGroupIndex++;

				const scheduleDisplay = getUserAssignmentTypeDisplay({ userAssignmentTypeId });
				sortRow = (
					<tr key={sortValue}>
						<td className={classes.sortGroupCell} style={style} colSpan={numberOfDays + 1}>
							{scheduleDisplay}
						</td>
					</tr>
				);
			}

			return (
				<Fragment key={userId}>
					{sortRow}
					<tr key={userId}>
						<UserRowHeader
							display={display}
							subDisplay={subDisplay}
							displayLink={displayLink}
							isOdd={index % 2}
							isDriverRoom={true}
						/>
						{dateColumns.map(({ date }) => {
							const userWorkDays = userWorkDaysByDate[date] || [];

							//- Happens on transfers
							if (_.isEmpty(userWorkDays)) {
								return (
									<Cell key={date} numberOfDays={numberOfDays} isOdd={index % 2}>
										<div style={{ color: '#999', fontSize: '90%' }}>n/a</div>
									</Cell>
								);
							}

							const isOdd = index % 2;

							return (
								<Cell numberOfDays={numberOfDays} key={date} isOdd={isOdd} isDriverRoom={true}>
									{userWorkDays.map((workDay) => {
										const { workDayId } = workDay;
										return (
											<div key={workDayId}>
												<WorkDay
													workDay={workDay}
													numberOfDays={numberOfDays}
													userMap={userMap}
													shiftMap={shiftMap}
													locationMap={locationMap}
													assignedLocationId={assignedLocationId}
													isDriverRoom={true}
													isOdd={isOdd}
													userRowCount={userRowCount}
												/>
											</div>
										);
									})}
								</Cell>
							);
						})}
					</tr>
				</Fragment>
			);
		});
	}
}

DriverRoomBody.propTypes = {
	classes: PropTypes.object.isRequired,
	calendarType: PropTypes.oneOf(['users', 'trucks']),
	refreshCalendarData: PropTypes.func.isRequired,
	locationIds: PropTypes.array,
};
DriverRoomBody.defaultProps = {
	calendarType: 'users',
};

export default withStyles(styles)(DriverRoomBody);
